<mat-accordion>
    <ac-expansion-panel [classes]="'operator-connect-expansion-panel ' + (cardHasError ? 'cardHasError' : '')"
                        [expanded]="true"
                        [headerTemplate]="headerTemplate"
                        [descriptionTemplate]="removeButton"
                        [descriptionObject]="{index: index, type: 'operatorContacts'}">
        <div>
            <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.operatorContactType'" label="Type">
                <ac-single-select [(acModel)]="contactObject.operatorContactType" (click)="$event.stopPropagation()"
                           (acModelChange)="operatorContactTypeWasSelected.emit($event)"
                           [items]="operatorContactTypesList"
                           bindLabel="viewName" bindValue="name">
                </ac-single-select>
            </ac-input-container>

            <div class="flexRowParentEqualChildren">
                <ac-input-container label="Title" [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.title'">
                    <ac-textfield [(acModel)]="contactObject.title"
                                  [textFieldId]="'tenant-services-operatorContacts-' + index + '-title'">
                    </ac-textfield>
                </ac-input-container>

                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.displayName'" label="Display Name">
                    <ac-textfield [(acModel)]="contactObject.displayName"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-displayName-' + index">
                    </ac-textfield>
                </ac-input-container>
            </div>

            <div class="flexRowParentEqualChildren">
                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.firstName'" label="First Name">
                    <ac-textfield [(acModel)]="contactObject.firstName"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-firstName' + index">
                    </ac-textfield>
                </ac-input-container>

                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.lastName'" label="Last Name">
                    <ac-textfield [(acModel)]="contactObject.lastName"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-lastName' + index">
                    </ac-textfield>
                </ac-input-container>
            </div>

            <div class="flexRowParentEqualChildren">
                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.email'" label="Email">
                    <ac-textfield [(acModel)]="contactObject.email"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-email' + index">
                    </ac-textfield>
                </ac-input-container>

                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.sipAlias'" label="SIP Alias">
                    <ac-textfield [(acModel)]="contactObject.sipAlias"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-sipAlias' + index">
                    </ac-textfield>
                </ac-input-container>
            </div>

            <div class="flexRowParentEqualChildren">
                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.phoneNumber'" label="Phone Number">
                    <ac-textfield [(acModel)]="contactObject.phoneNumber"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-phoneNumber' + index">
                    </ac-textfield>
                </ac-input-container>

                <ac-input-container [formFieldName]="'tenant.services.OC.info.operatorContacts.' + index + '.secondPhoneNumber'" label="Second Phone Number">
                    <ac-textfield [(acModel)]="contactObject.secondPhoneNumber"
                                  [textFieldId]="'tenant-operatorConnectInfo-operatorContacts-secondPhoneNumber' + index">
                    </ac-textfield>
                </ac-input-container>
            </div>
        </div>
    </ac-expansion-panel>

    <ng-template #headerTemplate>
        <div class="contact-panel-header">
            {{contactObject.title || ('Operator Contact ' + (index + 1))}}
        </div>
    </ng-template>
</mat-accordion>


